import React from "react";
import { Pressable, StyleSheet } from "react-native";

import CustomText from "../../../../../components/common/general/CustomText/CustomText";
import { colors } from "../../../../../styles/design-system";

interface FilterPillProps {
  label: string;
  isActive: boolean;
  onPress: () => void;
}

function FilterPill({ label, isActive, onPress }: FilterPillProps) {
  return (
    <Pressable
      onPress={onPress}
      role="button"
      accessibilityRole="button"
      accessibilityLabel={`Filter ${label}`}
      accessibilityState={{ selected: isActive }}
      style={[styles.filterPill, isActive && styles.filterPillActive]}>
      <CustomText
        text={label}
        useTranslationText={false}
        size="xs"
        style={[styles.filterPillText, isActive && styles.filterPillTextActive]}
      />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  filterPill: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 999,
    backgroundColor: "transparent",
  },
  filterPillActive: {
    backgroundColor: colors.grey[200],
  },
  filterPillText: {
    color: colors.grey[500],
    fontSize: 11,
    lineHeight: 16,
  },
  filterPillTextActive: {
    color: colors.grey[900],
    fontWeight: "500",
  },
});

export default FilterPill;
